export class FtpSettingsDto {
		host: string = "";
		port: string = "";
		username: string = "";
		password: string = "";
		donationsFilesFolder: string = "";
		pledgesFolder: string = "";
}